<template>
  <div class="page">
    <div class="banner">
      <el-carousel class="carousel-container" trigger="click" height="284px" >
        <el-carousel-item  key="1">
          <el-link href="https://api.tcyl.atanxin.com/user/policy?type=12&app_id=3" >
            <el-image style="width: 100%;" alt="玩法说明" src="https://static-ty.oss-cn-shanghai.aliyuncs.com/banner/5ed24765ab5037333da25c2bb3b3d4ecb19d63d0.png"></el-image>
          </el-link>
        </el-carousel-item>
        <el-carousel-item  key="2">
          <el-link href="https://api.tcyl.atanxin.com/user/policy?type=4&app_id=3" >
            <el-image style="width: 100%;" alt="自律公约" src="https://static-ty.oss-cn-shanghai.aliyuncs.com/banner/880c8882640b126ae1729f19b6c396d9ce956249.png"></el-image>
          </el-link>
        </el-carousel-item>
        <el-carousel-item  key="3">
          <el-link href="https://api.tcyl.atanxin.com/user/policy?type=6&app_id=3" >
            <el-image style="width: 100%;" alt="防诈骗指南" src="https://static-ty.oss-cn-shanghai.aliyuncs.com/banner/429106f1920cffa3967cc325eeee19b9b2ab05b9.png"></el-image>
          </el-link>
        </el-carousel-item>
        <el-carousel-item  key="4">
          <el-link href="https://api.tcyl.atanxin.com/user/policy?type=13&app_id=3" >
            <el-image style="width: 100%;" alt="防掉线指南" src="https://static-ty.oss-cn-shanghai.aliyuncs.com/banner/90ccc3ac5fa78aee7a0835d009f7d5a9fbf57550.png"></el-image>
          </el-link>
        </el-carousel-item>
        <el-carousel-item  key="5">
<!--          <el-link href="https://api.tcyl.atanxin.com/user/policy?type=13&app_id=3" >-->
            <el-image style="width: 100%;" alt="谨防诈骗" src="https://static-ty.oss-cn-shanghai.aliyuncs.com/banner_yue_liao/%E8%B0%A8%E9%98%B2%E8%AF%88%E9%AA%97banner.png"></el-image>
<!--          </el-link>/-->
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="main-container">
      <div class="top">
        <div class="search-box" style="background-color: transparent;" @click="goAddPage('SearchPage')">
          <input  type="text" placeholder="问题搜索" class="search-input" />
        </div>
        <div class="icon-top" style="display: flex;margin-top: 0;">
          <div class="icon-item" @click="goAddPage('certification')">
            <img src="../assets/img/certification.png" class="quest-img">
            <p class="quest-char">认证问题</p>
          </div>
          <div class="icon-item" @click="goAddPage('account')">
            <img src="../assets/img/account.png"class="quest-img">
            <p class="quest-char">账号问题</p>
          </div>
          <div class="icon-item" @click="goAddPage('money')">
            <img src="../assets/img/money.png" class="quest-img">
            <p class="quest-char">金币问题</p>
          </div>
          <div class="icon-item" @click="goAddPage('integral')">
            <img src="../assets/img/integral.png" class="quest-img">
            <p class="quest-char">积分问题</p>
          </div>
        </div>
        <!--        <div class="icon-top" style="display: flex">
                  <div class="icon-item" @click="goAddPage('member')">
                    <img src="../assets/img/member.png" class="qest-img">
                  </div>
                  <div class="icon-item" @click="goAddPage('level')">
                    <img src="../assets/img/level.png" class="qest-img">
                  </div>
                  <div class="icon-item" @click="goAddPage('common')">
                    <img src="../assets/img/common.png" class="qest-img">
                  </div>
                </div>-->
      </div>

      <div class="content">
        <div class="content-topic">
          <div class="content-title"><img src="../assets/img/hot.png" style="width: 17px;margin-right: 5px;">热门问题</div>
          <el-collapse v-model="activeNames">
            <el-collapse-item title="1.为什么大家都喜欢用陌生约聊交友" name="1">
              <div class="item-content">
                <p>[普惠]不用担心无人关注!</p>
                <p>陌生约聊以去中心化的运营理念，推行算法平权，给予用户平等的展示与匹配机制，致力于让每一位普通用户都得到推荐和关注;</p>
                <p>[真实]不用担心聊天是机器人回复!</p>
                <p>在陌生约聊，用户经过系统+人工双重审核，有超过9成的用户已通过真人认证;</p>
                <p>[高效]不用担心发送消息石沉大海!</p>
                <p>陌生约聊智能的Al匹配算法，能为你快速推荐相互有好感的异性，搭讪聊天回复率高，平均回复等待时间不超过9秒;</p>
                <p>聊天交友，就上陌生约聊!</p>
                <div style="height: 10px"></div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="2.发不了信息，提示充值？" name="2">
              <div class="item-content">
                <p>陌生约聊独创了付费聊天模式，聊天免费与付费，完全交由用户自主设置;</p>
                <p>当对方用户设置聊天需付费时发消息需付金币，对方12小时内不回复退还金币。</p>
                <p>对方用户设置免费时，发消息免费。</p>
                <p>聊天付费，可以主动追求你喜欢的人，并得到及时回应；还能过滤骚扰、验证诚意，可靠又高效;</p>
                <p>金币也不是必须充值，可通过做签到、做任务等方法免费获取金币。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="3.怎样才能获得更多金币？" name="3" class="last">
              <div class="item-content">
                <p>每日签到可免费获得金币，你还可以通过<span class="blue-text" @click="handleSpanClick('toDayTask')">做任务</span>等方法免费获取金币。如果他人主动向您发消息、赠送您礼物，都会给您增加积分。</p>
                <p>您的积分积累到一定程度可以兑换相对应的金币。</p>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>

        <div class="content-topic">
          <div class="content-title"><img src="../assets/img/question.png" style="width: 17px;margin-right: 5px;">更多问题</div>

          <el-collapse v-model="activeNames">
            <el-collapse-item title="1.亲密度为什么会下降？" name="5">
              <div class="item-content">
                <p>1)亲密度下降的比例是系统根据您与对方的具体互动情况自动判定哦</p>
                <p>2)可以通过与对方互动赠礼保持亲密度。</p>
                <p>3)维持亲密度的方法:赠送对方魅力值级别乘以10对应的金币额，即如果对方魅力值是16级，那么每天送给对方160金币以上就可以维持当前的亲密度了哦。</p>
                <p>4)当守护等级达到“终身守护”时，则双方亲密度永不下降，它将成为一段美丽佳话，永流传在平台。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="2.如何成为对方守护？" name="6">
              <div class="item-content">
                <p>1)当达到守护对方所需亲密度，就成为对方守护天使。</p>
                <p>2)守护分10级: LV1-LV10， 亲密度越高等级越高。</p>
                <p>3)每个人只有一个守护天使。</p>
                <p>4)你守护我，同时我也守护了你，即是互相守护;互相守护的用户可以上亲密榜，按双方亲密度之和排名。</p>
                <p>5)守护等级达到了10级，并亲密度达到了最高即会显示终身守护，成为终身守护后，与对方的亲密度将不再下降。</p>
                <p>温馨提示:文字、语音、视频聊天，以及赠送礼物均可增加亲密度，与对方的亲密度达到了一定程度即可守护，相互成为彼此的守护天使，语音、视频通话免费~</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="3.如何取代守护？" name="8">
              <div class="item-content">
                <p>现守护天使的亲密度高于原守护天使的亲密度，即会被取代守护天使的位置,展示现守护天使，同时被取代后系统会下发提醒通知。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="4.如何维持亲密度？" name="9">
              <div class="item-content">
                <p>每天需新增对方魅力值级别同等的亲密度，即如果对方魅力值是10级，那么每天只需要增加10亲密度就可以了。当守护等级达到“终身守护”时，则双方亲密度永不下降，它将成为一段美丽佳话，永流传在陌生约聊平台。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="5.客服工作时间？" name="10">
              <div class="item-content">
                <p>人工客服工作时间为：工作日8：00-17：30</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="6.如何上榜？" name="11">
              <div class="item-content">
                <p>上榜规则：</p>
                <p>1）亲密榜：</p>
                <p>①两个人亲密度之和排序</p>
                <p>②通过私聊、语音通话、视频通话、互送礼物提高亲密度，上亲密榜</p>
                <p>&nbsp;</p>
                <p>2）荣耀榜：</p>
                <p>①荣耀指数总数排序</p>
                <p>②可通过私聊、语音通话、视频通话、完成任务、送礼物等获得的荣耀指数，上荣耀榜</p>
                <p>&nbsp;</p>
                <p>3）女神榜：</p>
                <p>①女神指数总数排序</p>
                <p>②可通过私聊、语音通话、视频通话、签到、完成任务、收礼物等获得的女神指数，上女神榜</p>
                <p>&nbsp;</p>
                <p>③荣耀榜-同城榜前10名可抽取珍稀戒指，每天25枚</p>
                <p>4）男神榜</p>
                <p>①男神指数总数排序</p>
                <p>②可通过私聊、语音通话、视频通话、签到、完成任务、收礼物等获得的男神指数，上男神榜</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="7.贵族特权有哪些？" name="12">
              <div class="item-content">
                <p>1）点击设置-贵族特权设置，操作相关设置</p>
                <p>2）可设置：</p>
                <p>①隐身访问：偷偷关心TA，访问TA人不留足迹</p>
                <p>②排行榜隐身：除活动榜单外不上榜</p>
                <p>③守护者隐身：匿名守护，做一个低调的大佬</p>
                <p>④隐藏位置：所在地保密，保持神秘</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="8.排行榜多久更新一次？" name="13">
              <div class="item-content">
                <p>排行榜每隔1小时更新一次。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="9.如何上电视？" name="14">
              <div class="item-content">
                <p>打开软件首页缘分列表顶部电视飘屏，点“如何上电视”进行设置</p>
                <p>上电视要求：</p>
                <p>1.如何上表白墙：</p>
                <p>单次金币价格大于99金币，可上表白墙；</p>
                <p>2.如何上电视墙：</p>
                <p>单次金币价格大于 999 金币，可上电视墙,，并锁屏10秒;</p>
                <p>单次金币价格大于2999金币，可上电视墙,，并锁屏20秒;</p>
                <p>单次金币价格大于5999金币，可上电视墙，并锁屏30秒。</p>
                <p>3.如何上全服公告:</p>
                <p>单次金币价格大于 9999 金币，可上全服公告，并锁屏60秒。</p>
                <p>单次金币价格大于19999金币，可上全服公告，并锁屏80秒。金额越大，锁屏时间越长。</p>
                <p>开通公爵/亲王/帝皇，可上全服公告，并锁屏60秒/80秒/100秒</p>
                <p>4.成为守护</p>
                <p>成为守护花费金币大于99金币，可上表白墙/电视墙/全服公告，并根据金额锁屏对应时长。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="10.如何发送联系方式？" name="15">
              <div class="item-content">
                <p>关于发联系方式问题：</p>
                <p>1、双方还不够熟悉(亲密度未达到100°C)的话，贸然留其他联系方式可能存在风险，建议您与对方互动交往一段时间熟悉后，您可以尝试发送联系方式</p>
                <p>2、双方互动熟悉亲密度超过100°C后可以尝试发送联系方式，信息只要发送成功，双方均可正常查看到。</p>
                <p>3、发送后显示已读，即对方已经成功接收到您的信息。若发送失败，软件聊天页面有相应提醒。</p>
                <p>4、添加联系方式建立在双方自主意愿前提下，若对方已读说看不到或其他任何制造平台虚假规则进行欺骗，都是属于违规行为。</p>
                <p>5、平台对一切形式存在欺骗性行为严格禁止并坚决打击，发现违规行为可以 及时反馈提供违规账号，一经核实针对违规程度将给予相应的处罚。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="11.超过100度为什么还发不了联系方式？" name="16">
              <div class="item-content">
                <p>1)平台鼓励用户真诚交友，双方互动熟悉亲密度超过100°C后可以尝试发送联系方式。</p>
                <p>2)添加联系方式建立在双方自主意愿前提下，若对方已读说看不到或其他任何制造平台虚假规则进行欺骗，都是属于违规行为。</p>
                <p>3) 平台对一切形式存在欺骗性行为严格禁止并坚决打击，一经核实针对违规账号的违规程度将给予相应的处理。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="12.如何提升搭讪推荐？" name="17">
              <div class="item-content">
                <p>1)搭讪是根据搜索条件、交友需求账号活跃、违规频次，聊天质量等相关信息进行智能化推荐匹配。</p>
                <p>2)建议您可以主动一对一聊天提高聊天质量的，或者也可以在首页或者广场多互动。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="13.如何修改性别？" name="18">
              <div class="item-content">
                <p>性别暂不支持修改，还请您在注册时填写真实信息。平台提倡真人交友，还请谅解~</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="14.如何更改年龄" name="19">
              <div class="item-content">
                <p>您好，陌生约聊是真实的交友平台，提倡真诚交友，为保障交友的真实性，实名认证后会显示真实年龄，暂不支持修改哦~ </p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="15.充值退款问题？" name="20">
              <div class="item-content">
                <p>1)关于充值问题:充值过程中是有几个环节与流程，首先是需要选择充值数额，支付前也是需要确定数额后再进行付款操作，支付时会有弹框提醒二次确认，再进行支付，才可支付成功。</p>
                <p>2)充值都是以用户自身需求及自主意愿为前提，用户有充分的选择权及自主决定权，平台不做任何干预。</p>
                <p>3)在平台每笔充值及消费都是公开透明，点击收支记录查看相关消费清单。</p>
                <p>虚拟产品一经充值成功，不支持退款。已经充值的金币，您可以选择通过聊天/送礼的形式进行消费。</p>
                <p>充值贵族成功后，权益立即生效，同样不支持退款。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="16.什么是财富值？" name="22">
              <div class="item-content">
                <p>1)财富值反映一个用户的慷慨程度,用户消费金币越多，财富值越高。</p>
                <p>2)在个人资料页可查看财富等级。</p>
                <p>3)若使用中不想显示财富值等级，可点击设置，在隐私设置内设置隐藏即可。</p>
                <p>4)财富等级可通过:送礼物、守护、语音视频通话、语音视频速配、聊天等方式进行升级。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="17.什么是魅力值？" name="23">
              <div class="item-content">
                <p>1)魅力值反映一个用户的魅力程度,用户获得积分越多，魅力值越高。</p>
                <p>2)在个人资料页可查看魅力等级</p>
                <p>3)若使用中不想显示魅力值等级，可点击设置，在隐私设置内设置隐藏即可  </p>
                <p>4)魅力值等级可通过:获赠礼物、守护、语音视频通话、语音视频速配、聊天等方式进行升级</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="18.如何操作隐私设置？" name="24">
              <div class="item-content">
                <p>点击到【我的】 - 【设置】 -【隐私设置】</p>
                <p>1)可设置隐藏自己的守护天使、守护者、排行榜，礼物。</p>
                <p>2)以上设置关闭后，相关信息将对其他人隐藏，仅自己可见。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="19.如何做任务？" name="25">
              <div class="item-content">
                <p>您可以点击<span class="blue-text" @click="handleSpanClick('toDayTask')" >每日任务</span>有很多任务可以完成哟，例如每日签到、上传照片，音视频等都可以获取免费金币使用哦</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="20.如何查看访客记录？" name="26">
              <div class="item-content">
                <p>查看访客记录为<span class="blue-text" @click="handleSpanClick('toVip')">贵族特享</span>权益，需先成为<span class="blue-text"   @click="handleSpanClick('toVip')">贵族</span>才可以享有的权益哦，完成<span class="blue-text">真人认证</span>也可查看访客记录。</p>
                <p>具体步骤为：点击软件底部【我的】-【谁看过我】即可查看。</p>
                <p>访客记录不支持删除，系统自动显示近期最新来访记录。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="21.如何查看对方在不在线？" name="27">
              <div class="item-content">
                <p>目前暂无查询在线功能</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="22.如何更改所在地？" name="28">
              <div class="item-content">
                <p>陌生约聊致力于打造最真实的交友平台，为体现交友真实性，所在地由系统自动识别，暂不支持修改所在地，</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="23.互关视频聊天免费吗？" name="29">
              <div class="item-content">
                <p>1）互相关注即是好友，成为好友后完成实名认证双方发送信息是免费的；</p>
                <p>2）互相关注与视频通话收费没有关系，与对方互相成为守护天使且达到LV6永结同心，互相守护后音视频通话是免费的</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="24.视频看不到人怎么办？" name="30">
              <div class="item-content">
                <p>视频语音聊天对网络要求比较高，建议在网络环境比较好的情况下试试，或者在手机自带设置找到对应产品软件，操作清除历史数据，缓存试一下。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="25.为什么不能视频？" name="31">
              <div class="item-content">
                <p>视频语音聊天对网络要求比较高，建议在网络环境比较好的情况下试试，或者在手机自带设置找到对应产品软件，操作清除历史数据，缓存试一下。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="26.视频、语音速配如何使用？" name="32">
              <div class="item-content">
                <p>1)视频、语音速配功能需要通过真人认证、语音签名后才能开启权限。</p>
                <p>2)视频、语音速配能快速匹配有缘人，使用过程中需提高自我保护意识;严禁谩骂，涉黄，广告，讨论敏感话题等行为，若遇不良体验请立即挂断并举报。</p>
                <p>3)视频、语音速配每分钟通话是系统固定收费，具体扣费明细请在<span class="blue-text" @click="handleSpanClick('toGoldBill')">金币清单</span>查询。</p>
                <p>4)视频、语音速配通话获得积分具体到账明细请在<span class="blue-text" @click="handleSpanClick('toIntegralBill')">积分清单</span>查询</p>
                <p>5)每日视频、语音速配通话系统将会随机赠送金币红包奖励哦。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="27.音视频聊天是怎么收费的？" name="33">
              <div class="item-content">
                <p>1)视频、语音通话需要通过真人认证、语音签名后才能开启权限。</p>
                <p>2)视频、语音通话使用过程中需提高自我保护意识；严禁谩骂，涉黄，广告，讨论敏感话题等行为，若遇不良体验请立即挂断并举报。</p>
                <p>3)视频、语音通话价格设置点击<span class="blue-text" @click="handleSpanClick('toMoneySetting')">收费设置</span>。</p>
                <P>4)视频、语音通话获得积分具体到账明细请在<span class="blue-text" @click="handleSpanClick('toIntegralBill')">积分清单</span>查询</P>
                <P>5)双方互相守护等等级达到LV6后，视频语音免费通话</P>
                <p>6)每日语音、视频通话系统将会随机赠送金币红包奖励哦。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="28.如何设置收费？" name="34">
              <div class="item-content">
                <p>陌生约聊平台秉持平台公正公平原则，聊天收费或免费的功能权限完全交由用户自主设置；</p>
                <p>点击<span class="blue-text" @click="handleSpanClick('toMoneySetting')">收费设置</span>设置免费聊天或不同的收费标准；</p>
                <p>当对方设置发消息收费时，发消息给对方需付金币，对方12小时内回复即可获得相应积分。</p>
                <p>付费聊天，可以主动追求你喜欢的人，并得到及时回应，可靠且高效。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="29.为什么对方给我点赞或评论或收到私信？" name="35">
              <div class="item-content">
                <p>为提升聊天效率、增强互动，当对方给您的头像、相册、语音签名、动态等点赞或评论时，系统会依据平台大数据进行匹配，若匹配度高的男女双方,系统将帮您和对方搭桥牵线，对方点赞消息将同步发送私信通知您，您回复对方则视为接受缘分，判定为主动发送消息方，按照对方的收费设置标准进行付费，互相关注消息免费。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="30.为什么没有人回复我？" name="36">
              <div class="item-content">
                <p>你可以完善自己的个人资料，写下自己的交友宣言，发布高质量动态，这样会吸引更多人喜欢你，回复你哦~</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="31.如何更换头像？" name="37">
              <div class="item-content">
                <p>1）点击<span class="blue-text" @click="handleSpanClick('toAvatar')">上传头像</span>，更换您的头像</p>
                <p>2）请提交本人高清且无遮挡的人脸照片</p>
                <p>3）提交后，进入AI智能+人工审核过程，请耐心等待审核，一般2小时内会处理。</p>
                <p>4）建议不要频繁提交，若提示“更换头像过于频繁”请明天再试</p>
                <p>温馨提示：真人认证用户必须上传本人真人头像</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="32.什么是礼物？" name="38">
              <div class="item-content">
                <p>1）礼物可以彰显人气与魅力，礼物越多代表的人气越高，另外可以通过赠送礼物增进与好友之间的联系以及获取更多人的关注</p>
                <p>2）可点击【我的】-【资料页】进入礼物墙查看收到的礼物展示</p>
                <p>3）礼物消耗金币点击<span class="blue-text" @click="handleSpanClick('toGoldBill')">金币清单</span>查询到账明细</p>
                <p>4）收礼记录，礼物获得积分点击<span class="blue-text" @click="handleSpanClick('toIntegralBill')">积分清单</span>查询到账明细，请以实际到账为准</p>
                <p>5）礼物获得的积分可以在积分商城兑换提现、金币等</p>
                <p>【温馨提示】：礼物由用户自主自愿赠送，请通过正规途径获得，避免通过欺骗、诱导等违规手段获取，系统检测将给予违规账号相应处罚，严重将导致账号永久禁用</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="33.如何发布动态？" name="39">
              <div class="item-content">
                <p>1）动态是陌生约聊的社交功能之一，可以通过动态发表图文视频语音，您的粉丝将会在她的动态页面查看到您的最新消息，进行评论、点赞和转发。您也可以查看到您关注的玩家的最新消息喔。</p>
                <p>2）点击动态列表，即可发布动态</p>
                <p>3）点击我的动态即可查看自己发布的动态内容</p>
                <p>4）动态违规原因有：低俗涉黄、打广告、留其他联系方式、政治敏感、宗教迷信、第三方平台信息、二维码、未成年、诋毁辱骂平台或他人等行为</p>
                <p>5）动态建议发布正向、积极内容，若检测存在违规敏感信息，将会被系统屏蔽，严重将有可能被封号！</p>
                <p>6）若账号被对方拉黑，对方查看不到您的动态</p>
                <p>7）删除动态：点击我的动态，点击到动态详情页，点击右上角选项，点击【删除】按钮，删除即可</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="34.如何设置拉黑/移除黑名单？" name="40">
              <div class="item-content">
                <p>1）软件有拉黑功能设置，【聊天会话右上角】-【聊天设置】可设置拉黑</p>
                <p>2）拉黑后将不再收到对方的消息和呼叫，且在好友列表互相看不到对方，对方也无法查看动态相关信息</p>
                <p>3）拉黑后在发送消息时，聊天页面将会提醒“发送失败，对方已将你拉黑”，将无法与对方进行沟通交流</p>
                <p>4）已被拉黑对象可在【我】-【设置】-【黑名单】查看，也可在此页面操作移出黑名单</p>
                <p>5）移出拉黑后即双方可正常互动发送信息</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="35.如何搜索账号？" name="41">
              <div class="item-content">
                <p>1）在软件消息界面-右上角-搜索输入查询ID-【搜索】即可。</p>
                <p>2）目前只支持通过账号ID搜索查找对方，不支持通过昵称姓名搜索哦。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="36.丘比特牵线？" name="101">
              <div class="item-content">
                <p>1）丘比特牵线是由系统牵线，希望能匹配到您心仪的人。</p>
                <p>2）该功能的特点在于平台会根据用户的搜索条件等相关信息进行智能化推荐，无论男女用户均会收到该推荐。</p>
                <p>3）陌生约聊根据用户交友需求进行智能化推荐匹配，匹配算法具有个性化，随机性等特点。正如人与人之间的缘分一样，平台上许多单身男女也因此功能结缘相识，开启自己的爱情故事。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="37.软件聊天如何收费？" name="42">
              <div class="item-content">
                <p>关于聊天：</p>
                <p>平台为有交友需求的用户双方搭建聊天互动的桥梁，聊天免费或收费的功能权限完全交由用户自主设置；</p>
                <p>平台不强制用户充值消费，金币不一定要充值，用户可以通过签到、做任务等方法获取金币；</p>
                <p>用户聊天是否产生金币消耗也由用户自主设置，当对方用户设置聊天需付费时发消息需付金币，对方12小时内不回复退还金币。对方用户设置免费时，发消息免费。具体扣费明细请在<span class="blue-text" @click="handleSpanClick('toGoldBill')">金币清单</span>查询。</p>
                <p>收费模式的设置一方面是为了减少骚扰和垃圾广告行为的出现，另一方面也可以提高交友效率。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="38.身份认证已达上限怎么办？" name="43">
              <div class="item-content">
                <p>亲，根据平台规则，如果提示“身份证认证已上限”，说明您的身份证认证平台帐号数量已达上限。</p>
                <p>您可以先注销掉不用的帐号，等注销成功后再将身份证绑定到现在的账户中，绑定成功后再进行提现（提交注销后的15天后注销成功）</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="39.真人认证已达上限怎么办？" name="44">
              <div class="item-content">
                <p>亲，根据平台规则，您可明日在进行认证</p>
              </div>
            </el-collapse-item>
             <el-collapse-item title="40.为什么发送的消息有小感叹号？" name="45">
               <div class="item-content">
                 <p>亲，请您检查下发送内容中是否出现低俗、涉黄、暴力、时政等敏感词汇，一旦出现，消息会被屏蔽，我们提倡绿色交友，请注意维护绿色交友环境。</p>
               </div>
            </el-collapse-item>
             <el-collapse-item title="41.如何找回之前的账号？" name="46">
               <div class="item-content">
                 <p>亲，如果想要找回之前的账号，请您确认之前账号绑定的手机号是否还在正常使用，如果在正常使用，您可以选择使用手机号方式进行登录，登录后看到的就是之前的账号。</p>
                 <p>温馨提醒：</p>
                 <p>1、如果手机不用了，那么之前的账号就无法找回了，建议重新注册账号使用；</p>
                 <p>2、如您之前的账号是已经注销了，则不支持恢复。</p>
               </div>
            </el-collapse-item>
             <el-collapse-item title="42.为什么我的账号自动和别人打招呼？" name="47">
               <div class="item-content">
                 <p>亲，为了更快地帮您达成交友需求，系统爱神丘比特会主动帮您牵线。</p>
                 <p>在收到对方的回复后，如果感兴趣可以尝试聊天。</p>
                 <p>温馨提醒：可以在【我的设置】-【通用设置】中关闭丘比特爱神匹配这项功能。</p>
               </div>
            </el-collapse-item>
             <el-collapse-item title="43.为什么没有人打招呼/打招呼变少了/收不到打招呼信息？" name="48">
               <div class="item-content">
                 <p>陌生约聊独创的打招呼模式是基于大数据进行智能随机匹配，系统将根据账号活跃情况进行匹配。</p>
                 <p>若长时间未收到打招呼，请确认您是否在设置-通用设置关闭了丘比特牵线；</p>
                 <p>若收到较少打招呼或打招呼量降低，可通过完善资料、提高主动私聊频率等方式来提升账户质量。</p>
               </div>
            </el-collapse-item>
             <el-collapse-item title="44.为什么消息发不出去？" name="49">
               <div class="item-content">
                 <p>亲，若您的消息无法发送，请检查是否存在以下情况：</p>
                 <p>1. 检查网络情况是否良好，建议切换网络后尝试，例如4G网络换为wifi网络。</p>
                 <p>2. 检查发送内容中是否出现违禁词，例如个人联系方式、其他平台的名称缩写等敏感内容。</p>
                 <p>3. 检查发送内容中是否出现低俗、涉黄、暴力、时政等敏感词汇。</p>
                 <p>4. 检查账户内是否金币不足，请及时充值（贵族聊天也是正常收费的）。</p>
                 <p>5. 如果您被对方拉黑了，也是无法发送出去的。</p>
                 <p>6. 检查自己是否违规。</p>
               </div>
            </el-collapse-item>
            <el-collapse-item title="45.消息已读不回的原因？" name="50">
              <div class="item-content">
                <p>消息已读：消息发送成功显示已读，即是对方已经成功接收到信息并已查阅。</p>
                <p>已读不回：对方可能已读后不在线了或在忙不能及时回复；消息已成功接收是否回复信息取决于对方</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="46.如何删除聊天记录？" name="51">
              <div class="item-content">
                <p>1）若要删除某一条消息：在私聊页面，选择需删除信息，长按选择删除即可</p>
                <p>2）若要删除关于某个人关联的全部信息：在双方消息页面-点击右上角进入【聊天设置】-清空聊天记录</p>
                <p>3）若要删除列表：长按消息对话框，选择“清空消息列表”选项，即可清除</p>
                <p>温馨提示：消息删除后即无法恢复</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="47.聊天记录相关？" name="52">
              <div class="item-content">
                <p>1）为用户账号安全及对用户个人隐私的保护，平台对用户聊天记录不做保存，平台无法也无权利查看，仅用户自己可以查看，请放心使用</p>
                <p>2）操作删除聊天记录后，即无法恢复，还请谨慎操作</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="48.如何下载陌生约聊app？" name="53">
              <div class="item-content">
                <P>1）陌生约聊APP下载：安卓手机用户可以在各大手机应用商店；苹果手机用户可以在App Store</P>
                <P>2）注册页面提供了手机号码注册方式，注册即可</P>
                <P>3）若软件卸载了可以直接重新安装使用，没有其他限制</P>
                <P>4）软件卸载重装，APP内资料信息，账号金币/积分，相关数据均在，登录软件即可查看</P>
              </div>
            </el-collapse-item>
            <el-collapse-item title="49.亲密度如何增加？" name="54"  class="last">
              <div class="item-content">
                <p>您好，和对方聊天消耗10个金币等于1亲密度。您与对方聊天互动、音视频通话、赠送礼物等有金币消耗都会增加亲密度的哦。</p>
              </div>
            </el-collapse-item>

          </el-collapse>

        </div>

      </div>


    </div>
    <Service/>
  </div>
</template>

<script>
import Service from "./Service";


export default {
  name: 'Index',
  components: {Service},

  data() {
    return {
      activeNames: '',
    }
  },

  methods: {
    goAddPage(route) {
      this.$router.push(route);
    },
    handleSpanClick(value) {
      var basePath = "<%=basePath%>";
      var browser = {
        versions: function () {
          var u = navigator.userAgent, app = navigator.appVersion;
          return {//移动终端浏览器版本信息
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
          };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      };

      // 调用浏览器版本信息判断是IOS还是Android
      if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
        window.webkit.messageHandlers.WebToiOS.postMessage(value);
      } else {
        this.showInfoFromJs(value);
      }
    },
    showInfoFromJs(value) {
      return window.AndroidWebView.showInfoFromJs(value);
    },
  }
}
</script>


<style scoped>

/*.page {
  background-image: url("../assets/img/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-top: env(safe-area-inset-top);
}*/

.icon-top {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 22px 0px;
}
.icon-top .quest-img{
  width: 55px;
}

.icon-item {
  //width: 25%;
  //height: 100%;
  border-radius: 8px;
}

.hr {
  height: 10px;
  width: 100%;
  background: #F9FAFC;
}

.content {
  width: 100%;
  font-size: 15px;
}

.title-class {
}

.content-title {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
}

/deep/ .van-cell {
  color: #666666;
}

/deep/ .van-icon-circle2 {
  color: #3576F9;
}

/deep/ .van-icon-circle {
  color: #E6E5E5;
}

/deep/ .checked-title {
  font-size: 15px;
  color: #000000 !important;
}
/deep/ .unchecked {
  font-size: 15px;
}

.item-content {
  font-size: 13px;
  color: #555555;
  line-height: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.item-title {
  font-weight: 600;
}

.key-text{
  font-weight: 500;
  color: #4C30FC;
}

.item-img{
  width: 100%;
  text-align: center;
  margin-top: 30px;
}



.top {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.quest-img {
  width: 100%;
  height: 80%;
}

.quest-char {
  text-align: center;
  font-size: 14px;
  color: #666;
}
.content .content-topic:last-child{
  margin-bottom: 70px;
}
.content-topic{
  padding: 10px 13px;
  background-color: #ffffff;
  border-radius: 10px;
  margin-top: 15px;
}
.content-topic .el-collapse {
  border-top: none;
  border-bottom: none;
}
.content-topic .el-collapse-item__header {
  font-size: 15px;
}
.content-topic .last .el-collapse-item__header {
  border-bottom: none;
}
.customer-service {
  position: fixed;
  bottom: 30px;
  left: 80%;
  transform: translateX(-50%);
  width: 60px;
  height: 60px;
}

.customer-service img {
  width: 100%;
  height: 100%;
}


.search-box {
  margin:0px 0 15px 0px;
  display: flex;
}

.search-input {
  height: 35px;
  width: 100%;
  background-color: #fff;
  border-radius: 20px;
  background-image: url(../assets/img/problem-search.png);
  background-repeat: no-repeat;
  background-position: 15px center;
  background-size: 21px;
  text-indent: 42px;
  border: none;
}

.red-text {
  color: red;
}

.blue-text {
  color: cornflowerblue;
}

.page .banner{
  width: 100%;
  border-right: 1px solid #eff2f6;
  display: inline-block;
  box-sizing: border-box;

}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #ffffff;
}


.page{
  position: relative;
}
.main-container{
  border-radius: 23px 23px 10px 10px;
  margin-top: -26px;
  z-index: 999;
  position: relative;
  background-color: #f5f7fb;
  padding: 18px 18px 14px 18px;
}
</style>



// WEBPACK FOOTER //
// src/page/Index.vue